module.exports = __webpack_public_path__ + "static/bruce-mars-gJtDg6WfMlQ-unsplash-16_9-b6a2407c8e74ac44f9fa8c8b6b88e1a1.jpg";